module.exports = __webpack_public_path__ + "img/home-kurs-none.c9a9712f.png";